"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propTypes = _objectSpread({
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  selectedValues: _propTypes["default"].arrayOf(_propTypes["default"].string)
}, (0, _utils.togglePropTypes)('expanded'));

var defaultProps = {
  className: '',
  selectedValues: []
}; // Wraps the `DropdownCheckboxGroup` component

function DropdownSelect(_ref) {
  var children = _ref.children,
      className = _ref.className,
      expanded = _ref.expanded,
      selectedValues = _ref.selectedValues,
      toggleExpanded = _ref.toggleExpanded;
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "dropdown-select"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "select-input",
      onClick: toggleExpanded
    },
    /*#__PURE__*/
    _react["default"].createElement("p", null, getLabel(selectedValues))),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: (0, _classnames["default"])(className, 'options', {
        'is-active': expanded
      })
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "scroll-box"
    }, children)))
  );
}

DropdownSelect.propTypes = propTypes;
DropdownSelect.defaultProps = defaultProps;

function getLabel(values) {
  return values.length ? values.join(', ') : 'None';
}

function handleClickOutside(_ref2) {
  var setExpanded = _ref2.setExpanded;
  return setExpanded(false);
}

var _default = (0, _utils.compose)((0, _utils.toggle)('expanded'), (0, _utils.onOutsideClick)(handleClickOutside))(DropdownSelect);

exports["default"] = _default;